import { InputParameter } from "./inputParameters.model";

export class Model {
  modelId: number;
  modelName: string;
  modelType: string;
  inputParameters: InputParameter[];

  constructor() {
    this.modelId = 0;
    this.modelName = '';
    this.modelType ='';
    this.inputParameters = [];
  }
}
